const isTouchEvent = event => {
  var _event$touches, _event$changedTouches;
  return Boolean((event === null || event === void 0 ? void 0 : (_event$touches = event.touches) === null || _event$touches === void 0 ? void 0 : _event$touches.length) || (event === null || event === void 0 ? void 0 : (_event$changedTouches = event.changedTouches) === null || _event$changedTouches === void 0 ? void 0 : _event$changedTouches.length));
};

export { isTouchEvent as default, isTouchEvent };
//# sourceMappingURL=index.js.map
